export const urls = {
    // baseUrlRestApi: "https://restapi.mybestprod.xyz",
    // baseUrlBotApi: "https://botapi.mybestprod.xyz",
    // baseUrlSocketApi: "https://socketapi.mybestprod.xyz",
    baseUrlRestApi :"https://orange.jumiadash.store/api/v2",
    // baseUrlBotApi : "http://localhost:6002",
    baseUrlSocketApi: "https://socketorange.jumiadash.store",
    
}